var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WidgetTemplate',{attrs:{"subtitle":_vm.messages.subtitle,"image":_vm.image,"background-image":_vm.backgroundImage}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.messages.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }